import {Skeleton} from '@ui/shadcn/skeleton';

/** Skeleton-заглушка при lazy loading страниц (поверх `shadcn/skeleton`). */
export const PageSkeleton = () => (
  <div className='flex-1 p-6 space-y-4'>
    <Skeleton className='h-8 w-48' />
    <div className='grid grid-cols-4 gap-4'>
      {Array.from({length: 4}).map((_, i) => (
        <Skeleton key={i} className='h-24 rounded-lg' />
      ))}
    </div>
    <Skeleton className='h-64 rounded-lg' />
  </div>
);
